import React, { useEffect, useState } from "react";
import AdAccordion from "../layout/AdvanceAccordopn";
import LogNav from "../layout/LoggedNav";
import { getCoursesAlert } from "../../services/apiService";
import ENUMS from "../../utils/ENUMS";
import { ToastContainer } from "react-toastify";
import { getAuthData } from "../../services/authService";
const auth = getAuthData();

const CoursesAlert = () => {
  const token = localStorage.getItem(ENUMS.AUTH);
  const [alert, setAlert] = useState([]);

  useEffect(() => {
    getClubAlerts();
  }, [alert.length > 0]);

  const getClubAlerts = () => {
    getCoursesAlert(token).then((clubAlert) => {
      // console.log(clubAlert.data.data)
      setAlert(clubAlert.data.data);
    });
  };

  return (
    <>
      <section className="club_Login">
        <div className="page-width">
          <div className="acc-alert-data gap-block-section">
            <h1 className="text-jost-sb-50"></h1>
            {/* <LogNav /> */}
            <ToastContainer />
            <div className="acc-alert__accordion__wrap">
              <div className="acc-alert__accordion_head">
                <h1 className="text-jost-sb-24">Your Clubs Alerts</h1>
                <p className="text-ops-rg-16-wt">
                  Should you take longer than the allotted time to complete the
                  hole you are playing you will receive a text alert on your
                  phone notifying you that you are over the time that has been
                  allocated to pay the hole and request you to speed up
                </p>
              </div>
              <div className="acc-alert__accordion_content_wrap">
                {alert.length > 0 &&
                  alert.map((item, key) => {
                    return <AdAccordion alert={item} />;
                  })}
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default CoursesAlert;
